<template>

	<div>
		<span class="" v-if="uicontrol.success">{{__('newsletter.congratulations_text')}}</span>

		<div>

			<div class="mb-3">
				<p class="mt-1 mb-2 font-semibold " v-if="uicontrol.message_text" :class="uicontrol.message_class">{{__(uicontrol.message_text)}}</p>
				<p class="text-grey" v-if="!$store.state.central.subscribed_to_newsletter"></p>
				<!--<p class="font-semibold" v-else>{{__('newsletter.you_are_subscribed')}}</p>-->
			</div>

			<div class="d-flex mt-0">
				<div class="d-flex justify-content-end position-relative">
					<label for="email" class="offscreen-label">{{__('form.email')}}</label>
					<input type="email" class="form-control left-round right-square" id="email" v-model="email" placeholder="" required :disabled="$store.state.central.subscribed_to_newsletter || disable_input">
				</div>
				<div class="d-flex justify-content-end">
					<button class="btn btn-primary btn-sm left-square text-nowrap" type="submit" @click="submit()" :disabled="$store.state.central.subscribed_to_newsletter">
						{{__('subscribe')}}
					</button>
				</div>
			</div>

		</div>
	</div>

</template>

<script>


import {validateEmail} from "@/utility";

export default {
	name: "Newsletter",
	data() {
		return {
			email: null,
			disable_input: false,
			uicontrol: {
				message_text: '',
				message_class: ''
			},
		}
	},

	mounted() {
		if (this.$page.props.auth?.user) {
			this.email = this.$page.props.auth.user.email
			this.disable_input = true;
		}
	},

	methods: {

		submit() {

			if (!this.email || !validateEmail(this.email)) {
				this.uicontrol.message_class = 'text-danger';
				this.uicontrol.message_text = 'enter_email_address'
				return;
			}

			axios.post(route('newsletter.subscribe', {
				email: this.email
			})).then(r => {

				// Reset form
				this.uicontrol.message_text = 'newsletter.subscription_success';
				this.uicontrol.message_class = 'text-regular';
				this.email = null;

				// Set in store
				this.$store.commit('central/set', {
					subscribed_to_newsletter: true
				})

			}).catch(error => {
				console.log(error);
			})

		}

	}
}
</script>

<style scoped>

</style>